const OptionButton = ({ children, isActive = '', onClick }) => (
  <button
    type="button"
    className={`c-option-button ${isActive && 'c-option-button--active'}`}
    onClick={() => onClick(children)}>
    {children}
  </button>
);
export default OptionButton;
